module.exports = __webpack_public_path__ + "img/icon_production_tr.29077c7b.png";